// HeroSection.js
import React from "react";

const HeroSection = () => {
  const handleReadMore = () => {
    const articleLink =
      "https://smhatre59.medium.com/introducing-react30-master-react-js-in-30-days-by-building-17-practical-projects-0dbe5ea39b5b";
    window.open(articleLink, "_blank");
  };
  return (
    <section className="bg-blue-700 text-white py-16">
      <div className="container mx-auto flex flex-col md:flex-row items-center md:items-start md:justify-between">
        <div className="text-center md:text-left md:w-1/2">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
            React30
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl mb-8">
            Master React fundamentals by building 30 projects in 30 days.
          </p>
          <button
            className="bg-white text-blue-700 py-2 px-6 rounded-full hover:bg-gray-300"
            onClick={handleReadMore}
          >
            Learn More
          </button>
        </div>
        <div className="mt-8 md:mt-0 md:w-1/2">
          <img
            src={
              "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837387/React30/rs4ah2rzs0jbqftcbtqb.jpg"
            }
            alt="Hero image"
            className="mx-auto md:mx-4 w-full md:w-auto rounded-md shadow-md"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
